import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AUTH_ROUTES, canActivateUser } from '@shs-digi-care-monorepo/frontend-lib/auth';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { canActivateFeature } from './shared/guards/feature.guard';
import { EmeaFeature } from './shared/services/emea-feature.model';
import { OpenRequestTabsService } from './shared/services/open-request-tabs.service';

export const APP_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./menu/menu.component').then((m) => m.MenuComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request',
        loadComponent: () => import('./request/request.component').then((m) => m.RequestComponent),

        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'request/:id',
        redirectTo: (route) => inject(Router).createUrlTree(['/requests'], { queryParams: { tab: route.params['id'] } })
    },
    {
        path: 'requests',
        loadComponent: () => import('./requests/tasks.component').then((m) => m.TasksComponent),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser],
        // The request tabs only live while the overview is shown, so leaving it drops their unsaved edits.
        canDeactivate: [() => inject(OpenRequestTabsService).confirmDiscard()]
    },
    {
        path: 'tasks',
        redirectTo: (route) => inject(Router).createUrlTree(['/requests'], { queryParams: route.queryParams })
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateFeature(EmeaFeature.ADMIN_AREA)]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'auth',
        children: AUTH_ROUTES
    },
    {
        path: '**',
        redirectTo: ''
    }
];
